import {
  Required,
  Schema,
  TextField,
  RemoteDataSource
} from "lego-gui-lib/lib";
import { mainStore, api } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { ForeignKeyField } from "lego-gui-lib";
import { Auth } from "../../core/model/auth";

export const AreaSchema = new Schema({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ADMIN
  },
  fields: [
    {
      name: "name",
      type: TextField(Required),
      title: t("common:name")
    },
    {
      name: "prefix",
      type: TextField(Required),
      title: t("hns:area:prefix")
    }
  ]
});

export const EditAreaSchema = AreaSchema.extend({});

mainStore.area = RemoteDataSource.create({
  api: api,
  name: "area",
  schema: AreaSchema,
  url: "/areas",
  commons: mainStore.commons
});

mainStore.areaFk = RemoteDataSource.clone(mainStore.area);

export const AreaFK = ForeignKeyField(
  {
    dataSource: mainStore.areaFk.listDataSource,
    labelField: "name",
    valueField: "id"
  },
  Required
);

export const AreaFKNotRequired = ForeignKeyField({
  dataSource: mainStore.areaFk.listDataSource,
  labelField: "name",
  valueField: "id"
});
